import React from 'react';
import GetStartedContent from './content';
import { GetStartedProvider } from 'contexts/get-started.context';

const GetStartedLayout = () => {
  return (
    <GetStartedProvider>
      <GetStartedContent />
    </GetStartedProvider>
  );
};

export default GetStartedLayout;
